<template>
  <div class="pt-10 pb-5 component-div">
    <!-- PREVIEW MODE -->
    <template v-if="mode == 0">
      <b-row>
        <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            v-if="componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined)"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            >Optional</span
          >
          <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
            Skipped
          </div>
          <div class="ml-5" v-if="componentData && componentData.notifications && componentData.notifications.length > 0 && isNotificationIcon">
            <img alt="Bell icon" src="@/assets/NotificaionIcon.png" data-v-c76994f4 />
          </div>
        </b-col>
      </b-row>

      <b-row class="pl-45 pt-10">
        <b-form-textarea type="text" name="activityFormTextPreview" disabled rows="6" />
      </b-row>
    </template>

    <!-- EDIT MODE -->
    <template v-else-if="mode == 1">
      <b-row>
        <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence" :class="isFieldDisabled ? 'disable-question' : ''">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            :class="isFieldDisabled ? 'disable-question' : ''"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            :class="isFieldDisabled ? 'disable-question' : ''"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            v-if="componentData.isSkippable"
            >Optional</span
          >
          <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
            Skipped
          </div>
          <span class="text-warning pl-5 fw-bold" v-if="hasFieldWarning">{{ fieldWarningText }}</span>
          <span v-else-if="hasFieldError" class="text-danger pl-5 fw-bold">{{ fieldErrorText }}</span>
        </b-col>
      </b-row>

      <b-row class="mb-10 mt-5 pl-43" :class="isFieldDisabled ? 'disable-question' : ''">
        <b-col md="5" sm="12" class="p-0">
          <b-form-group class="mb-0" v-if="componentData.subType == 'height'">
            <div class="row" v-if="componentData.measurementUnit == 'cm'">
              <input class=" col-5 form-control form-control-sm" id="input-1" v-model="componentData.answer" type="number" :placeholder="translateToActiveLang('input_placeholder_height_length', 'Enter height/length')" :disabled="isFieldDisabled" @input="heightValid(componentData.answer)" :class="{ 'is-danger': hasFieldError }" />
              <span class="text-left my-2 ml-15 mr-15">cm</span>
            </div>
            <div class="row" v-if="componentData.measurementUnit == 'Feet-Inches'">
              <input class="col form-control form-control-sm" id="input-1" v-model="componentData.feet" type="number" :placeholder="translateToActiveLang('input_placeholder_height_length', 'Enter height/length')" :disabled="isFieldDisabled" @input="heightValid(componentData.feet)" :class="{ 'is-danger': hasFieldError }" />
              <span class="text-left my-2 ml-15 mr-15">ft</span>
              <input class="col form-control form-control-sm" v-model="componentData.inch" type="number" :placeholder="translateToActiveLang('input_placeholder_height_length', 'Enter height/length')" :disabled="isFieldDisabled" @input="heightValid(componentData.inch)" :class="{ 'is-danger': hasFieldError }" />
              <span class="my-2 text-left ml-15 mr-15">in</span>
            </div>
          </b-form-group>
          <b-form-group class="mb-0" v-if="componentData.subType == 'weight'">
            <div class="row" v-if="componentData.measurementUnit == 'kg'">
              <input id="input-1" class="col-5 form-control form-control-sm" v-model="componentData.answer" type="number" :placeholder="translateToActiveLang('input_placeholder_weight', 'Enter weight')" :disabled="isFieldDisabled" @input="weightValid(componentData.answer)" :class="{ 'is-danger': hasFieldError }" size="sm" />
              <span class="my-2 text-left ml-15 mr-15">kg</span>
            </div>
            <div class="row" v-else>
              <input class="col-5 form-control form-control-sm" id="input-1" v-model="componentData.answer" type="number" :placeholder="translateToActiveLang('input_placeholder_weight', 'Enter weight')" :disabled="isFieldDisabled" @input="weightValid(componentData.answer)" :class="{ 'is-danger': hasFieldError }" />
              <span class="my-2 text-left ml-15 mr-15">lbs</span>
            </div>
          </b-form-group>
          <b-form-group class="mb-0" v-if="componentData.subType == 'bloodpressure'">
            <div class="row">
              <input class="col form-control form-control-sm" id="input-1" v-model="componentData.sysValue" type="number" :placeholder="translateToActiveLang('input_placeholder_blood_pressure_systolic', 'Systolic value')" :disabled="isFieldDisabled" @input="bpValid(componentData.sysValue)" :class="{ 'is-danger': hasFieldError }" />
              <span class="my-2 text-left ml-15">/</span>
              <input class="col ml-10 form-control form-control-sm" id="input-1" v-model="componentData.diasValue" type="number" :placeholder="translateToActiveLang('input_placeholder_blood_pressure_diastolic', 'Diastolic value')" :disabled="isFieldDisabled" @input="bpValid(componentData.diasValue)" :class="{ 'is-danger': hasFieldError }" />
              <span class="my-2 text-left ml-15 mr-15">mmHg</span>
            </div>
          </b-form-group>
          <b-form-group class="mb-0" v-if="componentData.subType == 'measurements'">
            <div class="row">
              <input class="col-5 form-control form-control-sm" id="input-1" v-model="componentData.answer" type="number" :placeholder="translateToActiveLang('input_placeholder_value', 'Enter value here')" :disabled="isFieldDisabled" @input="measurementV(componentData.answer)" :class="{ 'is-danger': hasFieldError }" />
              <span class="my-2 text-left ml-15 mr-15">{{ componentData.measurementUnit }}</span>
            </div>
          </b-form-group>

          <b-form-group v-if="componentData.subType == 'temperature'">
            <div class="row">
              <input class="col-5 form-control form-control-sm" id="input-1" v-model="componentData.answer" type="number" :placeholder="translateToActiveLang('input_placeholder_temperature', 'Enter temperature')" :disabled="isFieldDisabled" @input="onFieldChange, isTemperature(componentData.answer)" :class="{ 'is-danger': hasFieldError }" />
              <span class="my-2 text-left ml-15 mr-15">
                {{ componentData.measurementUnit }}
              </span>
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="7"> </b-col>
        <b-col cols="8"></b-col>
      </b-row>
      <div :class="isFieldDisabled ? 'disable-question' : ''">
        <span class="activity-form__clear pl-43" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
        <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
          <label class="fs-12" v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
          <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
            {{ componentData.actualScore || showScore(componentData.skipScore) }}
          </div>
        </div>
      </div>
    </template>

    <!-- RESPONSE MODE -->
    <template v-else-if="mode == 2">
      <span :class="{ 'query-icon': isEdited }"></span>
      <b-row>
        <b-col cols="10" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            v-if="componentData.isSkippable && isFieldDisabled == false"
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            >Optional</span
          >
          <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
            Skipped
          </div>
        </b-col>
        <b-col :class="componentData.isEditedVersion ? 'col-6' : 'col-10'" class="pl-30">
          <span class="changed" v-if="componentData.isEditedVersion"></span>
          <div class="answers ml-16" v-if="componentData.measurementUnit == 'Feet-Inches'">{{ componentData.feet }} ft &nbsp; {{ componentData.inch }} in</div>
          <div class="answers ml-16" v-else-if="componentData.subType == 'bloodpressure'">{{ componentData.sysValue }} / {{ componentData.diasValue }} mmHg</div>
          <div class="answers ml-16" v-else>
            {{ componentData.answer }} {{ componentData.measurementUnit }}
            <!-- <span v-if="componentData.measurementUnit == 'SystolicandDiastolic'">mmHg</span> -->
          </div>
          <b-row class="pt-5">
            <div class="d-inline-block ml-16" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.actualScore) || showScore(componentData.skipScore) }}
              </div>
              <!-- <span v-if="componentData.excludeScore" class="ml-10">Score excluded from total</span> -->
            </div>
          </b-row>
        </b-col>
        <b-col v-if="componentData.isEditedVersion" class="col-6 previous-answer">
          <span class="previous-value-mark"></span>
          <div
            v-translate="{
              key: 'label_previous_value',
              val: lang,
              html: 'Previous value'
            }"
            class="answers previous-value"
          >
            Previous value
          </div>
          <div>
            {{ componentData.previousAnswer }}
            <span v-if="componentData.measurementUnit == 'mmHg'"></span>
            <span v-else-if="componentData.measurementUnit == 'Feet-Inches'"></span>
            <span v-else>{{ componentData.measurementUnit }}</span>
          </div>
          <b-row class="pt-5" v-if="componentData.previousAnswer">
            <div class="d-inline-block" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.previousActualScore) }}
              </div>
              <!-- <span v-if="componentData.excludeScore" class="ml-10">Score excluded from total</span> -->
            </div>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";

export default {
  name: "activity-form-measurements-preview",

  mixins: [langTranslate],

  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: ""
    };
  },
  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      default: false
    },
    mode: {
      default: 0
    },
    isEdited: null,
    activityInfo: {
      default: () => {}
    },
    triggerValidate: {
      type: Boolean,
      default: false
    },
    isNotificationIcon: Boolean
  },
  mounted() {
    this.updateValues();
    if (this.componentData.previousAnswer && this.mode == 2) {
      if (this.componentData.measurementUnit == "Feet-Inches") {
        const split = this.componentData.previousAnswer.split(".");
        const previousValue = split[0] + "\xa0ft" + "\xa0\xa0" + split[1] + "\xa0in";
        this.componentData.previousAnswer = previousValue;
      }
      if (this.componentData.measurementUnit == "mmHg") {
        const split = this.componentData.previousAnswer.split(",");
        const previousValue = split[0] + "\xa0" + "/" + "\xa0\xa0" + split[1] + "\xa0mmHg";
        this.componentData.previousAnswer = previousValue;
      }
    }
    if (this.mode == 0 || this.mode == 2) {
      if (this.componentData.isSkippable && this.componentData.answer == "") {
        this.componentData.actualScore = this.componentData.skipScore;
        this.componentData.computedScore = this.componentData.skipScore;
      }
    }
    if (this.mode == 2) {
      if (this.componentData.isSkippable && this.componentData.answer == "") {
        this.componentData.previousActualScore = this.componentData.skipScore;
      }
    }
    if (this.mode == 1 && !!this.componentData.answer) {
      this.onFieldChange();
    }
  },
  watch: {
    componentData: {
      handler() {
        this.updateValues();
      },
      deep: true
    },
    isFieldDisabled(val) {
      if (val === true) {
        this.resetField();
      }
    },
    triggerValidate() {
      if (!this.isFieldDisabled) {
        this.onFieldChange();
      }
    },
    hasFieldError(val) {
      this.componentData.hasFieldError = val;
    },
    fieldErrorText(val) {
      this.componentData.fieldErrorText = val;
    }
  },
  methods: {
    updateValues() {
      if (this.componentData.answer) {
        if (this.componentData.measurementUnit == "Feet-Inches") {
          const split = String(this.componentData.answer).split(".");
          this.$set(this.componentData, "feet", split[0]);
          this.$set(this.componentData, "inch", split[1]);
        } else if (this.componentData.subType == "bloodpressure") {
          const split = String(this.componentData.answer).split(",");
          if (split.length == 2) {
            this.$set(this.componentData, "sysValue", split[0]);
            this.$set(this.componentData, "diasValue", split[1]);
          }
        }
      }
    },
    showScore(score) {
      if (score) {
        return score;
      }
      return 0;
    },
    resetField() {
      this.componentData.answer = "";
      this.componentData.dataChecks = [];

      setTimeout(() => {
        this.componentData.computedScore = 0;
        this.componentData.actualScore = 0;
      }, 10);

      if (this.componentData.subType == "height") {
        this.componentData.feet = undefined;
        this.componentData.inch = undefined;
      } else if (this.componentData.subType == "bloodpressure") {
        if ((this.componentData.hasOwnProperty("minimumValue") && this.componentData.hasOwnProperty("maximumValue")) || !this.componentData.hasOwnProperty("maximumValue")) {
          this.componentData.sysValue = undefined;
          this.componentData.diasValue = undefined;
        } else {
          this.componentData.sysValue = " ";
          this.componentData.diasValue = " ";
        }
      }
      this.$nextTick(() => {
        this.$set(this.componentData, "answer", "");
      });

      this.componentData.answer = "";
      this.hasFieldError = false;
      this.hasFieldWarning = false;
      this.$emit("getQuestionScores");
    },
    clearAnswer() {
      this.resetField();
      this.$emit("onClearAnswer", this.componentData);
      this.resetAllErrors();
    },
    onFieldChange() {
      this.onAnswerChange();
      this.heightValid();
      this.weightValid();
      this.bpValid();
      this.measurementV();
      this.checkForFieldErrors();
    },
    validateCharacterLimit(answer, hasLimit, characterLimit) {
      if (hasLimit && answer.length > characterLimit) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_char_limit", `Character limit can not be more than ${characterLimit}`, { CHAR_LIMIT: characterLimit });
        return true;
      }
      if (hasLimit == false && answer.length > 4096) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_char_limit", `Character limit can not be more than ${characterLimit}`, { CHAR_LIMIT: 4096 });
        return true;
      }
      return false;
    },
    resetAllErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasFieldWarning = false;
      this.fieldWarningText = "";
    },
    checkForFieldErrors() {
      let { answer, characterLimited, textLimit, isSkippable, dataEditChecks, subType } = this.componentData;

      this.componentData.dataChecks = [];
      if (dataEditChecks) {
        let softDataCheck = false;
        for (let k = 0; k < dataEditChecks.length; k++) {
          if (dataEditChecks[k].check == "SOFT") {
            if (dataEditChecks[k].type == "DATA_FORMAT") {
              if (!Number.isInteger(Number(dataEditChecks[k].value))) {
                let validateDecimal = this.regulateDecimal(answer, dataEditChecks[k].value);
                if (!validateDecimal) {
                  let message = this.convertMessage(dataEditChecks[k].value);
                  this.hasFieldError = false;
                  this.hasFieldWarning = true;
                  this.fieldErrorText = "";
                  this.fieldWarningText = `Your response is not in the expected format: ${message}. Please review your response.`;
                  this.componentData.dataChecks.push({
                    dataCheckId: dataEditChecks[k].id,
                    dataCheckType: dataEditChecks[k].type,
                    message: this.fieldWarningText
                  });
                  softDataCheck = true;
                }
              } else if (Number.isInteger(Number(dataEditChecks[k].value))) {
                let validateDecimal = this.regulateDecimal(answer, dataEditChecks[k].value);
                if (!validateDecimal) {
                  let message = this.convertMessage(dataEditChecks[k].value);
                  this.hasFieldError = false;
                  this.hasFieldWarning = true;
                  this.fieldErrorText = "";
                  this.fieldWarningText = `Your response is not in the expected format: ${message}. Please review your response.`;
                  this.componentData.dataChecks.push({
                    dataCheckId: dataEditChecks[k].id,
                    dataCheckType: dataEditChecks[k].type,
                    message: this.fieldWarningText
                  });
                  softDataCheck = true;
                }
              }
            }

            if (dataEditChecks[k].type == "LESS_THAN") {
              let ansValue = answer;
              if (subType == "bloodpressure") {
                ansValue = ansValue.replace(/,/g, ".");
              }
              if (Number(ansValue) > dataEditChecks[k].value) {
                this.hasFieldError = false;
                this.hasFieldWarning = true;
                this.fieldErrorText = "";
                isSkippable = true;
                this.fieldWarningText = `Your response is greater than the expected range ${dataEditChecks[k].value}. Please review your response.`;
                this.componentData.dataChecks.push({
                  dataCheckId: dataEditChecks[k].id,
                  dataCheckType: dataEditChecks[k].type,
                  message: this.fieldWarningText
                });
                softDataCheck = true;
              }
            }
            if (dataEditChecks[k].type == "GREATER_THAN") {
              let ansValue = answer;
              if (subType == "bloodpressure") {
                ansValue = ansValue.replace(/,/g, ".");
              }
              if (Number(ansValue) < dataEditChecks[k].value) {
                this.hasFieldError = false;
                this.hasFieldWarning = true;
                this.fieldErrorText = "";
                isSkippable = true;
                this.fieldWarningText = `Your response is less than the expected range ${dataEditChecks[k].value}. Please review your response.`;
                this.componentData.dataChecks.push({
                  dataCheckId: dataEditChecks[k].id,
                  dataCheckType: dataEditChecks[k].type,
                  message: this.fieldWarningText
                });
                softDataCheck = true;
              }
            }
          } else {
            if (dataEditChecks[k].type == "DATA_FORMAT") {
              if (!Number.isInteger(Number(dataEditChecks[k].value))) {
                const validateDecimal = this.regulateDecimal(answer, dataEditChecks[k].value);
                if (!validateDecimal) {
                  const message = this.convertMessage(dataEditChecks[k].value);
                  this.hasFieldError = true;
                  this.fieldErrorText = `Please enter a response using format: ${message}.`;
                  isSkippable = false;
                  return false;
                }
              } else if (Number.isInteger(Number(dataEditChecks[k].value))) {
                const validateDecimal = this.regulateDecimal(answer, dataEditChecks[k].value);
                if (!validateDecimal) {
                  const message = this.convertMessage(dataEditChecks[k].value);
                  this.hasFieldError = true;
                  this.fieldErrorText = `Please enter a response using format: ${message}.`;
                  isSkippable = false;
                  return false;
                }
              }
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }
      if (!isSkippable && (answer == "" || answer == undefined) && this.isFieldDisabled == false) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_required", "This field is required.");
        return;
      }
      if (this.validateCharacterLimit(answer, characterLimited, textLimit)) {
        return;
      }
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.componentData.computedScore = this.componentData.score;
        this.componentData.actualScore = this.componentData.score;
        this.$emit("onAnswerChange", this.componentData);
      });

      if (this.componentData.subType == "height") {
        if (this.componentData.measurementUnit == "Feet-Inches" && !!this.componentData.feet && !!this.componentData.inch) {
          this.componentData.isDecimalField = true;
          this.componentData.answer = this.componentData.feet + "." + this.componentData.inch;
        } else if (this.componentData.measurementUnit == "Feet-Inches" && !!this.componentData.feet) {
          this.componentData.answer = this.componentData.feet;
        } else {
          this.componentData.answer = "";
        }
      } else if (this.componentData.subType == "bloodpressure" && !!this.componentData.sysValue && !!this.componentData.diasValue) {
        this.componentData.answer = this.componentData.sysValue + "," + this.componentData.diasValue;
      } else if (this.componentData.subType == "bloodpressure" && !!this.componentData.sysValue) {
        this.componentData.answer = this.componentData.sysValue;
      } else if (this.componentData.subType == "bloodpressure" && !!this.componentData.diasValue) {
        this.componentData.answer = this.componentData.diasValue;
      }
    },
    weightValid(answerData) {
      if (answerData) {
        this.resetAllErrors();
      }
      const answers = this.componentData;

      if (answers.isDisplayMinumumValueField && answers.minimumValue && answers.maximumValue) {
        if (answers.answer > answers.maximumValue || (answers.answer < answers.minimumValue && !answers.answer == "")) {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_number_between", `Please enter a number that is between ${answers.minimumValue} and ${answers.maximumValue}.`, { MIN_NUM: answers.minimumValue, MAX_NUM: answers.maximumValue });
        }
      }
      if (!answers.minimumValue || !answers.maximumValue) {
        if (answers.answer < answers.minimumValue && !answers.answer == "") {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_min_number", `Please enter a number that is greater than ${answers.minimumValue}.`, { MIN_NUM: answers.minimumValue });
        }
        if (answers.answer > answers.maximumValue && !answers.answer == "") {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_max_number", `Please enter a number that is less than ${answers.maximumValue}.`, { MAX_NUM: answers.maximumValue });
        }
      }
      if (answers.isSkippable == false) {
        if (answers.answer == "" && this.isFieldDisabled == false) {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_required", "This field is required.");
        }
      }

      this.onAnswerChange();
      this.checkForFieldErrors();
      this.measurementV();
    },
    heightValid(answerData) {
      if (answerData) {
        this.resetAllErrors();
      }
      const heightAnswer = this.componentData;

      if (heightAnswer.isDisplayMinumumValueField && heightAnswer.minimumValue && heightAnswer.maximumValue) {
        if (heightAnswer.feet > heightAnswer.maximumValue || (heightAnswer.feet < heightAnswer.minimumValue && !heightAnswer.feet == "")) {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_number_between", `Please enter a number that is between ${heightAnswer.minimumValue} and ${heightAnswer.maximumValue}.`, {
            MIN_NUM: heightAnswer.minimumValue,
            MAX_NUM: heightAnswer.maximumValue
          });
        }
        if (heightAnswer.inch > heightAnswer.maximumValue || (heightAnswer.inch < heightAnswer.minimumValue && !heightAnswer.inch == "")) {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_number_between", `Please enter a number that is between ${heightAnswer.minimumValue} and ${heightAnswer.maximumValue}.`, {
            MIN_NUM: heightAnswer.minimumValue,
            MAX_NUM: heightAnswer.maximumValue
          });
        }

        if ((heightAnswer.measurementUnit == "cm" && heightAnswer.answer > heightAnswer.maximumValue) || (heightAnswer.answer < heightAnswer.minimumValue && !heightAnswer.answer == "")) {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_number_between", `Please enter a number that is between ${heightAnswer.minimumValue} and ${heightAnswer.maximumValue}.`, {
            MIN_NUM: heightAnswer.minimumValue,
            MAX_NUM: heightAnswer.maximumValue
          });
        }
      }
      if (!heightAnswer.minimumValue || !heightAnswer.maximumValue) {
        if (heightAnswer.measurementUnit == "cm" && heightAnswer.answer > heightAnswer.maximumValue && !heightAnswer.answer == "") {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_max_number", `Please enter a number that is less than ${heightAnswer.maximumValue}.`, { MAX_NUM: heightAnswer.maximumValue });
        } else if (heightAnswer.measurementUnit == "cm" && heightAnswer.answer < heightAnswer.minimumValue && !heightAnswer.answer == "") {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_min_number", `Please enter a number that is greater than  ${heightAnswer.minimumValue}.`, { MIN_NUM: heightAnswer.minimumValue });
        }

        if (heightAnswer.feet > heightAnswer.maximumValue && !heightAnswer.feet == "") {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_max_number", `Please enter a number that is less than ${heightAnswer.maximumValue}.`, { MAX_NUM: heightAnswer.maximumValue });
        } else if (heightAnswer.feet < heightAnswer.minimumValue && !heightAnswer.feet == "") {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_min_number", `Please enter a number that is greater than  ${heightAnswer.minimumValue}.`, { MIN_NUM: heightAnswer.minimumValue });
        }

        if (heightAnswer.inch > heightAnswer.maximumValue && !heightAnswer.inch == "") {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_max_number", `Please enter a number that is less than ${heightAnswer.maximumValue}.`, { MAX_NUM: heightAnswer.maximumValue });
        } else if (heightAnswer.inch < heightAnswer.minimumValue && !heightAnswer.inch == "") {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_min_number", `Please enter a number that is greater than ${heightAnswer.minimumValue}.`, { MIN_NUM: heightAnswer.minimumValue });
        }
      }
      if (heightAnswer.isSkippable == false) {
        if (heightAnswer.feet == "") {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_ft_required", "Ft value is required.");
        } else if (heightAnswer.inch == "") {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_in_required", "In value is required.");
        }

        if (heightAnswer.measurementUnit == "cm" && heightAnswer.answer == "") {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_in_required", "Cm value is required.");
        }
      }
      this.onAnswerChange();
      this.checkForFieldErrors();
    },
    bpValid(answerData) {
      if (answerData) {
        this.resetAllErrors();
      }
      const answerBp = this.componentData;
      if (answerBp.subType != "bloodpressure") {
        return;
      }
      if ((!!answerBp.sysValue && answerBp.sysValue.match(/\./g)) || (!!answerBp.diasValue && answerBp.diasValue.match(/\./g))) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_decimal_not_allow", `Decimals not allowed`);
      } else if (!!answerBp.sysValue && !!answerBp.diasValue) {
        if (answerBp.systolicMaximumValue || answerBp.diastolicMaximumValue) {
          if (answerBp.sysValue > answerBp.systolicMaximumValue) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_systolic_val_max", `Please enter a systolic number that is less than ${answerBp.systolicMaximumValue}.`, { SYSTOLIC_MAX_VAL: answerBp.systolicMaximumValue });
          }
          if (answerBp.diasValue > answerBp.diastolicMaximumValue) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_diastolic_val_max", `Please enter a diastolic number that is less than ${answerBp.diastolicMaximumValue}.`, { DIASTOLIC_MAX_VAL: answerBp.diastolicMaximumValue });
          }
        }
        if (answerBp.systolicMinimumValue || answerBp.diastolicMinimumValue) {
          if (answerBp.sysValue < answerBp.systolicMinimumValue) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_systolic_val_min", `Please enter a systolic number that is greater than ${answerBp.systolicMinimumValue}.`, { SYSTOLIC_MIN_VAL: answerBp.systolicMinimumValue });
          }
          if (answerBp.diasValue < answerBp.diastolicMinimumValue) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_diastolic_val_min", `Please enter a diastolic number that is greater than ${answerBp.diastolicMinimumValue}.`, { DIASTOLIC_MIN_VAL: answerBp.diastolicMinimumValue });
          }
        }
        if (answerBp.isDisplayMinumumValueField && answerBp.isDisplayMaximumValueField) {
          if (answerBp.sysValue > answerBp.systolicMaximumValue || (answerBp.sysValue < answerBp.systolicMinimumValue && !answerBp.sysValue == "")) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_systolic_val_between", `Please enter a systolic number that is between ${answerBp.systolicMinimumValue} and ${answerBp.systolicMaximumValue}.`, {
              SYSTOLIC_MIN_VAL: answerBp.systolicMinimumValue,
              SYSTOLIC_MAX_VAL: answerBp.systolicMaximumValue
            });
          }
          if (answerBp.diasValue > answerBp.diastolicMaximumValue || (answerBp.diasValue < answerBp.diastolicMinimumValue && !answerBp.diasValue == "")) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_diastolic_val_between", `Please enter a diastolic number that is between ${answerBp.diastolicMinimumValue} and ${answerBp.diastolicMaximumValue}.`, {
              DIASTOLIC_MIN_VAL: answerBp.diastolicMinimumValue,
              DIASTOLIC_MAX_VAL: answerBp.diastolicMaximumValue
            });
          }
        }
      } else {
        if (answerBp.isSkippable == false) {
          if (!answerBp.sysValue) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_systolic_required", "Systolic value is required.");
          } else if (!answerBp.diasValue) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_diastolic_required", "Diastolic value is required.");
          }
        }
      }
      this.onAnswerChange();
      this.checkForFieldErrors();
    },
    measurementV(answerData) {
      if (answerData) {
        this.resetAllErrors();
      }

      if (this.componentData.isDecimalField && this.componentData.answer) {
        const charCode = this.componentData.answer.toString();
        if (charCode.includes(".")) {
          const numb = charCode.split(".")[1];
          if (numb != null && numb.length > this.componentData.decimalPlace) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_decimal_places", `Up to ${this.componentData.decimalPlace} decimals are allowed.`, { DECIMAL_PLACES: this.componentData.decimalPlace });
            return false;
          }
        }
      }

      if (this.componentData.subType != "temperature" && this.componentData.subType != "bloodpressure") {
        if (this.componentData.dataEditChecks) {
          for (let k = 0; k < this.componentData.dataEditChecks.length; k++) {
            if (this.componentData.dataEditChecks[k].type == "DATA_FORMAT") {
              this.componentData.isDecimalField = true;
            }
          }
        }

        if (!this.componentData.isDecimalField && this.componentData.answer.match(/\./g)) {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_decimal_not_allow", `Decimals not allowed`);
        }
      }

      if (this.componentData.isDisplayMinumumValueField && this.componentData.minimumValue && this.componentData.maximumValue) {
        if (this.componentData.answer > this.componentData.maximumValue || (this.componentData.answer < this.componentData.minimumValue && !this.componentData.answer == "")) {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_number_between", "Please enter a number that is between\xa0" + this.componentData.minimumValue + "\xa0and\xa0" + this.componentData.maximumValue + ".", {
            MIN_NUM: this.componentData.minimumValue,
            MAX_NUM: this.componentData.maximumValue
          });
        }
      }
      if (!this.componentData.minimumValue || (!this.componentData.maximumValue && this.componentData.answer)) {
        if (this.componentData.answer > this.componentData.maximumValue && !this.componentData.answer == "") {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_max_number", "Please enter a number that is less than\xa0" + this.componentData.maximumValue + ".", { MAX_NUM: this.componentData.maximumValue });
        } else if (this.componentData.answer < this.componentData.minimumValue && !this.componentData.answer == "") {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_min_number", "Please enter a number that is greater than\xa0" + this.componentData.minimumValue + ".", { MIN_NUM: this.componentData.minimumValue });
        }
      }
      if (this.componentData.isSkippable == false) {
        if (this.componentData.answer == "" && this.isFieldDisabled == false) {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_required", "This field is required.");
        }
      }
      this.onAnswerChange();
      this.checkForFieldErrors();
    },
    isTemperature() {
      this.resetAllErrors();
      const answerTemp = this.componentData;
      if (answerTemp.subType == "temperature") {
        if (answerTemp.answer == "") {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_required", "This field is required.");
        } else if (this.componentData.subType == "temperature" && answerTemp.maximumValue && answerTemp.minimumValue) {
          if (Number(answerTemp.answer) > Number(answerTemp.maximumValue) || Number(answerTemp.answer) < Number(answerTemp.minimumValue)) {
            this.hasFieldError = true;
            this.fieldErrorText = this.translateToActiveLang("validation_error_number_between", "Please enter a number that is between\xa0" + answerTemp.minimumValue + "\xa0Min" + "\xa0and\xa0" + answerTemp.maximumValue + "\xa0Max\xa0" + ".", {
              MIN_NUM: answerTemp.minimumValue,
              MAX_NUM: answerTemp.maximumValue
            });
          }
        } else if (answerTemp.isDisplayMinumumValueField && !answerTemp.isDisplayMaximumValueField && Number(answerTemp.answer) < Number(answerTemp.minimumValue)) {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_min_number", "Please enter a number that is greater than\xa0" + answerTemp.minimumValue + ".", { MIN_NUM: answerTemp.minimumValue });
        } else if (answerTemp.isDisplayMaximumValueField && !answerTemp.isDisplayMinumumValueField && Number(answerTemp.answer) > Number(answerTemp.maximumValue)) {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_max_number", "Please enter a number that is less than\xa0" + answerTemp.maximumValue + ".", { MAX_NUM: answerTemp.maximumValue });
        }
      }
      this.onAnswerChange();
      this.checkForFieldErrors();
    },
    validateAllowNegativeValues(answer, allowNegative) {
      if (allowNegative) {
        return false;
      }
      if (answer < 0) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_negative_number", "Negative value not allowed");
        return true;
      }
    },
    regulateDecimal(answer, decimal) {
      if (decimal.includes(".") && answer.includes(".")) {
        let decimalValue = decimal.split(".");
        let answerValue = answer.split(".");
        if (answerValue[0].replace(/\s/g, "").length > decimalValue[0] || !answerValue[0].trim().length) {
          return false;
        }
        if (answerValue[1].replace(/\s/g, "").length > decimalValue[1] || !answerValue[1].trim().length) {
          return false;
        }
      } else if (decimal.includes(".") && answer.includes(",")) {
        let decimalValue = decimal.split(".");
        let answerValue = answer.split(",");
        if (answerValue[0].replace(/\s/g, "").length > decimalValue[0] || !answerValue[0].trim().length) {
          return false;
        }
        if (answerValue[1].replace(/\s/g, "").length > decimalValue[1] || !answerValue[1].trim().length) {
          return false;
        }
      } else if (decimal.includes(".")) {
        return false;
      } else if (!!decimal.includes(".") && answer.includes(",")) {
        let answerValue = answer.split(",");
        if (answerValue[0].replace(/\s/g, "").length > decimal || !answerValue[0].trim().length) {
          return false;
        }
        if (answerValue[1].replace(/\s/g, "").length > decimal || !answerValue[1].trim().length) {
          return false;
        }
      } else if (answer.length > decimal) {
        return false;
      }

      return true;
    },
    convertMessage(number) {
      let stringMessage = "";

      if (number.includes(".")) {
        const numberValue = number.split(".");
        for (let i = 1; i <= numberValue[0]; i++) {
          stringMessage += "x";
        }
        stringMessage += ".";
        for (let i = 1; i <= numberValue[1]; i++) {
          stringMessage += "y";
        }
      } else {
        for (let i = 1; i <= number; i++) {
          stringMessage += "x";
        }
      }

      return stringMessage;
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 60px;
  border-radius: 1px;
  background-color: #ffa200;
}

.previous-value-mark {
  width: 3px;
  height: 65px;
  background-color: #ffa200;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.answers {
  font-weight: 600;
}

.previous-answer {
  opacity: 0.8;
}

.previous-value {
  color: #ffa200;
  opacity: 0.8;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 9px;
  letter-spacing: 2.4px;
  margin-top: 3px;
}
.activity-form__clear {
  width: 29px;
  height: 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c8ce4;
}
.number-sequence {
  min-width: 29px;
  display: inline-block;
}
.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}

.cursor_pointer1 {
  cursor: pointer;
  width: 22px;
  height: 20px;
  border-radius: 4px;
  background-color: #c4c4c4;
  display: inline-block;
  color: #fff;
  text-align: center;
}
.clearOptionDisabled {
  pointer-events: none !important;
}
</style>
